import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { IFieldConfig } from './report';
import { useContext } from 'react';
import { OrgSettingsContext } from '../../../contexts/org-settings-context';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { IOrderDeliveryTask, IPickupTask } from '../../../interfaces/delivery-company/tasks';

interface ReportTableHeaderProps<T extends OrderType | IPickupTask | IOrderDeliveryTask> {
  fields_config: IFieldConfig<T>[];
  color: string;
}

export function ReportTableHeader<T extends OrderType | IPickupTask | IOrderDeliveryTask>({
  fields_config,
  color,
}: ReportTableHeaderProps<T>) {
  const styles = StyleSheet.create({
    container: {
      flexDirection: 'row',
      borderBottomColor: color,
      backgroundColor: color,
      // borderBottomWidth: 1,
      alignItems: 'center',
      textAlign: 'center',
      height: "auto",
      fontWeight: 'bold',
      padding: 2,

      flexGrow: 1,

    },
  });

  return (
    <View style={styles.container}>
      {fields_config.map((config_item, index) => (
        <Text
          key={index}
          style={{
            width: config_item.width_percentage,
            borderRightColor: color,
            borderRightWidth: 1,
            color: 'white',
          }}
        >
          {config_item.display_name.map((item) => (
            <>
              {item} {'\n'}
            </>
          ))}
        </Text>
      ))}
    </View>
  );
}
